module.exports = __webpack_public_path__ + "static/media/bangko-sentral-logo.b7d6bf46.png";